import Close from '@mui/icons-material/Close';
import { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Tooltip from '@mui/material/Tooltip';
import { t } from 'i18next';

import { Ticket } from '~hooks/useTickets/models';

interface DeleteLoadColumnProps {
  isDeleting?: boolean;
  onDeleteLoadClick?: () => void;
  sx?: SxProps<Theme>;
  ticket?: Ticket;
}

export default function DeleteLoadColumn({
  isDeleting,
  onDeleteLoadClick,
  sx,
  ticket,
}: DeleteLoadColumnProps) {
  const hasTicket = Boolean(ticket);

  return (
    <Box sx={{ ...sx }}>
      {onDeleteLoadClick ? (
        <Tooltip
          title={hasTicket ? t('loads.remove_load_and_ticket') : t('loads.remove_load')}
        >
          {isDeleting ? (
            <Box
              sx={{
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'center',
                mt: '6px',
              }}
            >
              <CircularProgress color="secondary" size={15} />
            </Box>
          ) : (
            <Close
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                onDeleteLoadClick();
              }}
              sx={(theme) => ({
                color: theme.brandV2.colors.treadGray3,
                fontSize: '16px',
                mt: '3px',
                '&:hover': { color: theme.brandV2.colors.treadBlack },
              })}
            />
          )}
        </Tooltip>
      ) : null}
    </Box>
  );
}
